import { render } from "./RadioListOpenableField.vue?vue&type=template&id=1a516724"
import script from "./RadioListOpenableField.vue?vue&type=script&lang=js"
export * from "./RadioListOpenableField.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/application/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__